<template>
  <div class="wrap">
    <order-card
      :orderInfo="orderInfo"
      :showAddressNotice="showAddressNotice"
      :isModifyAddress="isModifyAddress"
    ></order-card>
    <div class="order-wrap border-ce5 mt-32">
      <h3 class="text-c111 font-s20 mt-24 ml-24">
        {{ TLang('订单详情', 'list') }}
      </h3>
      <!-- 遍历仓库订单 -->
      <deliveryParcelItem
        :orderInfo="orderInfo"
        :deliveryList="deliveryList"
        :isShowPrice="orderInfo.isShowPrice"
      >
      </deliveryParcelItem>
    </div>
    <div class="border-ce5 mt-16">
      <div class="settle-wrap">
        <div v-if="orderInfo.isShowPrice === 1" class="settle-wrap-item">
          <span class="font-c666"
            >{{ TLang('totalProduct1', 'orderConfirm') }}
            <em class="font-s14">{{ settleAccountInfo.totalNums }}</em>
            {{ TLang('totalProduct2', 'orderConfirm') }}，{{
              TLang('商品总价', 'list')
            }}{{ getCurrentUnionName(union_name || TLang('福豆', 'card')) }}:
          </span>
          <span class="text-num-c111">{{
            Number(orderInfo.totalPrice * union_scale).toFixed(2)
          }}</span>
        </div>
        <div v-if="orderInfo.isShowPrice === 1" class="settle-wrap-item mt-12">
          <span class="font-c666">
            {{ TLang('运费', 'orderConfirm')
            }}{{ getCurrentUnionName(union_name || TLang('福豆', 'card')) }}:
          </span>
          <span class="text-num-c111">{{
            Number(orderInfo.freight * union_scale).toFixed(2)
          }}</span>
        </div>
        <div
          v-if="orderInfo.isShowPrice === 1 && orderInfo.serviceFee > 0"
          class="settle-wrap-item mt-12"
        >
          <span class="font-c666"> {{ TLang('平台服务费', 'my') }}: </span>
          <span class="text-num-c111">{{
            Number(orderInfo.serviceFee * union_scale).toFixed(2)
          }}</span>
        </div>
        <!-- 福拼拼的不展示 立减、优化券 企业专享 -->
        <div v-if="orderInfo && orderInfo.groupItem !== 'Y'">
          <div
            v-if="orderInfo.activityReducePrice && orderInfo.isShowPrice === 1"
            class="settle-wrap-item mt-12"
          >
            <span class="font-c666">
              {{ TLang('立减', 'orderConfirm') }}({{
                union_name || TLang('福豆', 'card')
              }}):
            </span>
            <span class="text-num-c111"
              >-{{
                Number(
                  (orderInfo.activityReducePrice -
                    (settleAccountInfo.additionalDiscountAmount || 0)) *
                    union_scale
                ).toFixed(2)
              }}</span
            >
          </div>
          <div
            v-if="orderInfo.couponAmount && orderInfo.isShowPrice === 1"
            class="settle-wrap-item mt-12"
          >
            <span class="font-c666">
              {{ TLang('优惠券', 'orderConfirm') }}({{
                union_name || TLang('福豆', 'card')
              }}):
            </span>
            <span class="text-num-c111"
              >-{{
                Number(orderInfo.couponAmount * union_scale).toFixed(2)
              }}</span
            >
          </div>
          <div
            v-if="
              orderInfo.additionalDiscountAmount && orderInfo.isShowPrice === 1
            "
            class="settle-wrap-item mt-12"
          >
            <span class="font-c666">
              {{ TLang('专享优惠', 'orderConfirm') }}({{
                union_name || TLang('福豆', 'card')
              }}):
            </span>
            <span class="text-num-c111"
              >-{{
                Number(
                  orderInfo.additionalDiscountAmount * union_scale
                ).toFixed(2)
              }}</span
            >
          </div>
        </div>
        <div
          v-if="
            orderInfo.orderStatus === 1 &&
              settleAccountInfo.totalAmount !== settleAccountInfo.totalPayment
          "
        >
          <div
            v-if="orderInfo.isShowPrice === 1"
            class="settle-wrap-item mt-12"
          >
            <span class="font-c666"> {{ TLang('合计', 'orderConfirm') }}</span>
            <span>
              <img
                v-if="orderInfo && orderInfo.groupItem !== 'Y'"
                :src="union_icon || require('@/assets/images/fudou.png')"
                alt=""
                class="fudou-12"
              />
              <em class="text-num-c111"
                >{{ showRmbSymbol('&#65509;')
                }}{{
                  Number(orderInfo.totalPayment * union_scale).toFixed(2)
                }}</em
              >
            </span>
          </div>
          <div
            v-if="orderInfo.isShowPrice === 1"
            class="settle-wrap-item mt-20"
          >
            <span class="text-bold-c666">
              {{ TLang('还需支付', 'orderConfirm') }}
            </span>
            <span>
              <img
                v-if="orderInfo && orderInfo.groupItem !== 'Y'"
                :src="union_icon || require('@/assets/images/fudou.png')"
                alt=""
                class="fudou-15"
              />
              <em class="text-num-bold-red font-s20"
                >{{ showRmbSymbol('&#65509;')
                }}{{
                  Number(
                    orderInfo && orderInfo.unpaidAmount * union_scale
                  ).toFixed(2)
                }}</em
              >
            </span>
          </div>
          <div
            class="settle-wrap-item mt-20 clearfix"
            style="position: relative"
          >
            <!-- <el-tooltip
              v-if="orderInfo.auditStatus === 'audit'"
              class="item"
              effect="dark"
              :content="TLang('请在订单审核通过后完成支付', 'paypending')"
              placement="bottom-end"
            > -->
            <div
              v-if="orderInfo.auditStatus === 'audit'"
              class="btn-theme-w150 fr"
              :style="'opacity: 0.5'"
              @mouseenter="auditStatusShow = true"
              @mouseleave="auditStatusShow = false"
            >
              {{ TLang('继续支付', 'list') }}
            </div>
            <!-- </el-tooltip> -->
            <div
              v-if="orderInfo.auditStatus != 'audit'"
              class="btn-theme-w150 fr"
              :style="'opacity:1'"
              @click="locationToPaymentPage(orderInfo)"
            >
              {{ TLang('继续支付', 'list') }}
            </div>
            <div
              v-if="auditStatusShow"
              class="tips-audit"
              @click="auditStatusShow = false"
            >
              {{ TLang('请在订单审核通过后完成支付', 'paypending') }}
            </div>
          </div>
        </div>
        <div v-else>
          <div
            v-if="orderInfo.isShowPrice === 1"
            class="settle-wrap-item mt-12"
          >
            <span class="font-c666"> {{ TLang('合计', 'orderConfirm') }}</span>
            <span>
              <img
                v-if="orderInfo && orderInfo.groupItem !== 'Y'"
                :src="union_icon || require('@/assets/images/fudou.png')"
                alt=""
                class="fudou-15"
              />
              <em class="text-num-bold-red font-s20"
                >{{ showRmbSymbol('&#65509;')
                }}{{
                  Number(orderInfo.totalPayment * union_scale).toFixed(2)
                }}</em
              >
            </span>
          </div>
        </div>
      </div>
      <div v-if="orderInfo.orderStatus > 1" class="paid-wrap">
        <div v-if="paymentList && paymentList.length > 0">
          <div class="text-c111 font-s16 mtb mlr">
            {{ TLang('支付明细', 'list') }}
          </div>
          <div class="paid-thead card-default pt-12 pb-12 plr">
            <span class="font-c666">{{ TLang('支付方式', 'my') }}</span>
            <span class="font-c666">{{ TLang('东方福利卡号', 'list') }}</span>
            <span class="font-c666">{{ TLang('支付金额/次额', 'list') }}</span>
            <span class="font-c666">{{ TLang('支付时间', 'list') }}</span>
            <span class="font-c666">{{ TLang('状态', 'list') }}</span>
          </div>
          <div class="plr pt-24 pb-24">
            <!-- 遍历支付信息 pt-24 index 0-->
            <div
              v-for="(paymentItem, i) in paymentList"
              :key="i"
              class="paid-tbody-item"
            >
              <span>{{
                paymentItem.title || paymentItem.payWayStr || '-'
              }}</span>
              <span>{{ paymentItem.cardNo || '—' }}</span>
              <!-- status 1 为点卡 status 13 积分兑换,显示金额与货币单位参与比例换算 -->
              <span v-if="orderInfo.isShowPrice === 1"
                >{{
                  paymentItem.status === 1 || paymentItem.status === 13
                    ? paymentItem.value * union_scale
                    : paymentItem.value
                }}{{
                  paymentItem.status === 1 || paymentItem.status === 13
                    ? union_name
                    : paymentItem.unit
                }}</span
              ><span v-else>&nbsp;</span>
              <span>{{ paymentItem.payTime }}</span>
              <span>{{ TLang('支付成功', 'orderConfirm') }}</span>
            </div>
          </div>
        </div>
        <div class="line"></div>
        <div v-if="refundList.length !== 0">
          <div class="text-c111 font-s16 mt-24 mlr mb-16">
            {{ TLang('退款明细', 'list') }}
          </div>
          <div class="paid-thead card-default pt-12 pb-12 plr">
            <span class="font-c666">{{ TLang('退款方式', 'list') }}</span>
            <span class="font-c666">{{ TLang('东方福利卡号', 'list') }}</span>
            <span class="font-c666">{{ TLang('支付金额/次额', 'list') }}</span>
            <span class="font-c666">{{ TLang('支付时间', 'list') }}</span>
            <span class="font-c666">{{ TLang('状态', 'list') }}</span>
          </div>

          <div class="paid-tbody plr pt-24 pb-24">
            <!-- 遍历支付信息 pt-24 index 0-->
            <div
              v-for="(refundItem, i) in refundList"
              :key="i"
              class="paid-tbody-item"
            >
              <span>{{ refundItem.title }}</span>
              <span>{{ refundItem.refundAccount || '—' }}</span>
              <span
                >{{
                  refundItem.status === 1 || refundItem.status === 13
                    ? refundItem.value * union_scale
                    : refundItem.value
                }}{{
                  refundItem.status === 1 || refundItem.status === 13
                    ? union_name
                    : refundItem.unit
                }}</span
              >
              <span>{{ refundItem.refundTime }}</span>
              <span>{{ refundItem.refundStatusDesc }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="address-list">
      <BaseDialog
        v-show="addressListDialog"
        :show="addressListDialog"
        :title="TLang('修改地址', 'address')"
      >
        <div class="pb-12 prelative">
          <div class="lists" @scroll="test">
            <div
              v-for="(item, i) in addressList"
              :key="item.id"
              class="text addressItem"
            >
              <div
                @click="
                  () => {
                    modifyAddressItem = item
                    index = i
                  }
                "
              >
                <img
                  :src="
                    i !== index
                      ? require('@assets/images/order/address_check.png')
                      : require('@assets/images/order/address_checked.png')
                  "
                  alt="check"
                />
                <span>{{ item.consignee }} {{ item.mobile }}</span>
              </div>
              <div class="font-c999 line-clamp-1 pl-20">
                {{
                  item.provinceName +
                    item.cityName +
                    item.regionName +
                    item.streetName +
                    item.address
                }}
              </div>
            </div>
          </div>
          <!-- <div
            v-if="!hideShape && addressList && addressList.length > 7"
            class="shade"
          ></div> -->
          <div
            :class="['btn-empty', CookiesOne == 'en-US' ? 'addNewBtn' : '']"
            @click="handleCreateAddress"
          >
            + {{ TLang('新建收货地址', 'orderConfirm') }}
          </div>
        </div>
        <div class="dialog-footer clearfix">
          <div class="btn-theme-w112 fl" @click="onConfirmListAddressDialog">
            {{ TLang('确认', 'address') }}
          </div>
          <div
            class="btn-default-w112 ml-24 fl"
            @click="addressListDialog = !addressListDialog"
          >
            {{ TLang('取消', 'address') }}
          </div>
        </div>
      </BaseDialog>
    </div>
    <!-- <Popups
      ref="popus"
      :title="TLang('新建地址','address')"
      :isClearForm="clearForm"
      :showPopus="addressDetailDialog"
      :areaList="limitArea"
      @onConfirmEditAddressDialog="onConfirmEditAddressDialog"
      @onCancelEditAddressDialog="onCancelEditAddressDialog"
    /> -->

    <Popups
      v-if="!union_isBilingual && (!CookiesOne || CookiesOne != 'en-US')"
      ref="popus"
      :title="TLang('新建地址', 'address')"
      :isClearForm="clearForm"
      :showPopus="addressDetailDialog"
      :areaList="limitArea"
      @onConfirmEditAddressDialog="onConfirmEditAddressDialog"
      @onCancelEditAddressDialog="onCancelEditAddressDialog"
    />
    <PopupsEn
      v-if="union_isBilingual || (CookiesOne && CookiesOne == 'en-US')"
      ref="popus"
      :title="TLang('新建地址', 'address')"
      :isClearForm="clearForm"
      :showPopus="addressDetailDialog"
      :areaList="limitArea"
      @onConfirmEditAddressDialog="onConfirmEditAddressDialog"
      @onCancelEditAddressDialog="onCancelEditAddressDialog"
    />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import Cookies from 'js-cookie'
import BaseDialog from '@components/dialogV2'
import deliveryParcelItem from './deliveryParcelItem'
import orderCard from './components/orderCard'
import Toast from '@components/simpleToast'
import Popups from '../OrderConfirm/components/orderAddress/popups'
import PopupsEn from '../OrderConfirm/components/orderAddress/popupsEn'
import API_ENV from '@utils/API_ENV'
import {
  getNewAddAddress,
  getAddressDetails,
  getAddressList2,
  fetchUpdateAddressDelivery,
  fetchAddressAreaLimit,
} from '@fetch/address'
import { getPayUrl } from '@fetch/order'
import { unionFlag } from '@utils'

export default {
  name: 'OrderDetail',
  components: {
    orderCard,
    deliveryParcelItem,
    BaseDialog,
    Popups,
    PopupsEn,
  },
  data() {
    return {
      addressListDialog: false,
      auditStatusShow: false,
      addressDetailDialog: false,
      clearForm: true,
      modifyAddressItem: {},
      addressList: null,
      index: -1, // 地址列表默认不选中第一条，也默认不选中当前地址列表
      showAddressNotice: false,
      hideShape: false,
      updatedAddressItem: {},
      limitArea: [],
      CookiesOne: Cookies.get('df_lang'),
    }
  },
  computed: {
    ...mapState('orderDetail', [
      'orderInfo',
      'paymentList',
      'refundList',
      'deliveryList',
      'isModifyAddress',
    ]),
    ...mapGetters('orderDetail', {
      settleAccountInfo: 'getSettleAccountInfo',
    }),
  },
  created() {
    this.initData()
  },
  methods: {
    ...mapActions('orderDetail', ['getOrderDetailInfo']),
    initData() {
      const orderNo = this.$route.params.id
      this.getOrderDetailInfo({ orderNo })
      getAddressList2().then((res) => {
        this.addressList = res
        this.modifyAddressItem = this.addressList[0]
      })
    },
    // 获取当前单位字符
    getCurrentUnionName(union_name) {
      if (this.orderInfo && this.orderInfo.groupItem === 'Y') {
        if (this.orderInfo.groupItemShowRmbSymbol === 'Y') {
          return `(${TLang('元', 'orderConfirm')})`
        } else {
          return ''
        }
      } else {
        return `(${union_name})`
      }
    },
    // 是否显示人民币符号¥或者元
    showRmbSymbol(union) {
      let unionName = ''
      // 福拼拼
      if (this.orderInfo && this.orderInfo.groupItem === 'Y') {
        if (this.orderInfo.groupItemShowRmbSymbol === 'Y') {
          unionName = union
        }
      }
      return unionName
    },
    handleCreateAddress() {
      this.clearForm = false
      this.$nextTick(() => {
        this.addressListDialog = !this.addressListDialog
      })
      if (this.addressList.length >= 25) {
        Toast.info(this.TLang('抱歉地址最多只能有25条', 'orderConfirm'))
        return
      }
      this.clearForm = false
      this.$nextTick(() => {
        this.addressDetailDialog = !this.addressDetailDialog
      })
      this.limitArea.push(this.orderInfo.provinceId)
      this.limitArea.push(this.orderInfo.cityId)
    },
    locationToPaymentPage(orderInfo) {
      if (orderInfo.auditStatus === 'audit') {
        this.auditStatusShow = !this.auditStatusShow
        return
      }
      // const union = unionFlag() || sessionStorage.getItem('dffl_union');
      const params = {
        orderNo: orderInfo.orderNo,
        terminalType: 'PC',
        // returnUrls:{
        //   returnMechantUrl:encodeURIComponent(`${location.origin}/shop/home`),
        //   returnOrderListUrl:encodeURIComponent(`${location.origin}/shop/order/list`),
        //   returnOrderDetailUrl:encodeURIComponent(`${location.origin}/shop/order/detail/${orderInfo.orderNo}`)
        // }
      }
      // if(union){
      //   window.location.href = orderInfo.payUrl;
      //   return;
      // }
      getPayUrl(params).then((res) => {
        if (res && res.url) {
          window.location.href = res.url
        } else {
          setTimeout(() => {
            this.getOrderDetailInfo({ orderNo: orderInfo.orderNo })
          }, 1000)
        }
      })
    },
    onConfirmListAddressDialog() {
      const { modifyAddressItem } = this
      const orderNo = this.$route.params.id

      // 检查地址是否在疫区
      try {
        fetchAddressAreaLimit({
          regionId: modifyAddressItem.regionId,
          streetId: modifyAddressItem.streetId,
          cityId: modifyAddressItem.cityId,
          provinceId: modifyAddressItem.provinceId,
        })
          .then((res) => {
            // 这个不在疫区，才走下一步fetchUpdateAddressDelivery判断
            if (res.allowDelivery === 0) {
              Toast.info(res.promptWords, 1.5)
            } else {
              this.onConfirmNext()
            }
          })
          .catch(() => {
            this.onConfirmNext()
          })
      } catch (error) {
        this.onConfirmNext()
      }
    },
    onConfirmNext() {
      const { modifyAddressItem } = this
      const orderNo = this.$route.params.id

      fetchUpdateAddressDelivery({
        orderNo: orderNo,
        address: modifyAddressItem.address,
        receiverName: modifyAddressItem.consignee,
        receiverMobile: modifyAddressItem.mobile,
        district: modifyAddressItem.regionId,
        districtName: modifyAddressItem.regionName,
        streetId: modifyAddressItem.streetId,
        streetName: modifyAddressItem.streetName,
        addressId: modifyAddressItem.id,
        city: modifyAddressItem.cityId,
        cityName: modifyAddressItem.cityName,
        province: modifyAddressItem.provinceId,
        provinceName: modifyAddressItem.provinceName,
      })
        .then((res) => {
          if (res && res.msg) {
            Toast.info(res.msg, 1.5)
            setTimeout(this.initData(), 2000)
          }
          this.index = -1
          this.cancelDialog()
        })
        .catch(() => {
          this.index = -1
          this.cancelDialog()
        })
    },

    onConfirmEditAddressDialog(modifyAddressItem) {
      const orderNo = this.$route.params.id
      getNewAddAddress(modifyAddressItem).then((res) => {
        if (!res) return
        getAddressDetails({
          id: res,
        }).then((result) => {
          if (!result) return
          const item = result

          // 检查地址是否在疫区
          try {
            fetchAddressAreaLimit({
              regionId: item.regionId,
              streetId: item.streetId,
              cityId: item.cityId,
              provinceId: item.provinceId,
            })
              .then((res) => {
                // 这个不在疫区，才走下一步fetchUpdateAddressDelivery判断
                if (res.allowDelivery === 0) {
                  this.clearForm = false
                  Toast.info(res.promptWords, 1.5)
                } else {
                  this.onConfirmEditNext(item)
                }
              })
              .catch(() => {
                this.onConfirmEditNext(item)
              })
          } catch (error) {
            this.onConfirmEditNext(item)
          }
        })
      })
    },
    onConfirmEditNext(item) {
      const orderNo = this.$route.params.id
      this.clearForm = true

      fetchUpdateAddressDelivery({
        orderNo: orderNo,
        address: item.address,
        receiverName: item.consignee,
        receiverMobile: item.mobile,
        district: item.regionId,
        districtName: item.regionName,
        streetId: item.streetId,
        streetName: item.streetName,
        addressId: item.id,
        city: item.cityId,
        cityName: item.cityName,
        province: item.provinceId,
        provinceName: item.provinceName,
      })
        .then((res) => {
          if (res && res.msg) {
            Toast.info(res.msg, 1.5)
            setTimeout(this.initData(), 2000)
          }
          this.cancelDialog()
        })
        .catch(() => {
          this.cancelDialog()
        })
    },

    onCancelEditAddressDialog() {
      this.addressDetailDialog = false
      this.clearForm = true
    },
    cancelDialog() {
      this.addressListDialog = false
      this.clearForm = true
    },
    navigatorProductDetal(item) {
      if (item.channel && [14, 41, 71].includes(Number(item.channel))) {
        // 14-超值馈， 41-福鲜生，该频道目前仅开放官网H5，PC端不支持商详浏览
        Toast.info('该商品在此无法查看，请前往移动端查看。')
      } else if (item.channel && item.channel === 7) {
        let origin = ''
        if (API_ENV === 'test05' || API_ENV === 'development') {
          // 生产环境
          origin = '//exchange-test05.dongfangfuli.com'
        } else if (API_ENV === 'uat' || API_ENV === 'stage') {
          // 生产环境
          origin = '//exchange-stage.dongfangfuli.com'
        } else {
          origin = '//exchange.dongfangfuli.com'
        }
        window.location.href = `${origin}/bfd_gift_pc/productDetail?goodsId=${item.goodsId}&categoryId=${item.categoryId}`
      } else if (!item.compositeGoodsId) {
        const union = unionFlag() || sessionStorage.getItem('dffl_union')
        if (
          item.channel &&
          [16, 999, 20, 22, 42].includes(Number(item.channel)) &&
          !union
        ) {
          Toast.info('该商品在此无法查看，请前往东方福利网app查看')
        } else {
          this.$router.push(
            `/product/detail?cid=${item.categoryId}&gid=${item.goodsId}`
          )
        }
      } else {
        Toast.info(this.TLang('组合商品不支持查看详情', 'orderConfirm'), 1.5)
      }
    },
    test(event) {
      if (event.target.scrollTop === 0) {
        this.hideShape = false
      }

      if (event.target.scrollTop >= event.target.clientHeight) {
        // console.log(event.target.scrollTop);
        // console.log(event.target.clientHeight);
        this.hideShape = true
      }
    },
  },
}
</script>

<style lang="less" scoped>
.tips-audit {
  width: 201px;
  background: rgba(0, 0, 0, 0.8);
  position: absolute;
  right: 0px;
  margin-top: 58px;
  max-height: 41px;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  line-height: 19px;
  padding: 10px 8px;
  border-radius: 4px;
}
.tips-audit::before {
  content: '';
  position: absolute;
  width: 0px;
  height: 0px;
  top: -14px;
  right: 45px;
  border-top: 7px solid transparent;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid rgba(0, 0, 0, 0.8);
}
.settle-wrap {
  .card-theme;
  padding: 24px;

  .settle-wrap-item {
    text-align: right;
    span {
      display: inline-block;

      &:last-of-type {
        width: 11%;
      }
    }
  }
}
.paid-wrap {
  .paid-thead,
  .paid-tbody-item {
    span {
      display: inline-block;
    }
    :nth-child(1) {
      width: 21%;
    }
    :nth-child(2) {
      width: 24%;
    }
    :nth-child(3) {
      width: 24%;
    }
    :nth-child(4) {
      width: 21%;
    }
  }
  .paid-tbody-item {
    padding-bottom: 12px;
    &:last-of-type {
      padding-bottom: 0 !important;
    }
  }
}

.address-list {
  /deep/ .el-dialog__body {
    border-top: solid 1px #e5e5e5;

    ::-webkit-scrollbar {
      display: block;
      margin-right: 16px;
      width: 4px;
      height: 80px;
      background: rgba(229, 229, 229, 1);
      border-radius: 2px;
    }

    .lists {
      max-height: 463px;
      overflow-y: scroll;

      .addressItem {
        padding: 10px 20px;
        &:hover {
          background-color: #f8fcff;
          cursor: pointer;
        }
      }
    }

    .shade {
      width: 98%;
      height: 64px;
      position: absolute;
      bottom: 44px;
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 1) 100%
      );
    }

    .btn-empty {
      width: 120px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      border-radius: 4px;
      border: 1px solid rgba(229, 229, 229, 1);
    }

    .dialog-footer {
      padding-top: 32px;
      border-top: solid 1px #e5e5e5;
    }
  }
}
.addNewBtn {
  width: auto !important;
  max-width: 200px;
}
</style>
